
/**
 * @param {Date} expiredDate 
 * @returns {Boolean}
 */
export const getIsExpiredDate = (expiredDate) => {
  const currentTime = new Date().getTime();
  const expiredTime = expiredDate.getTime();
  return currentTime < expiredTime;
};